  document.querySelectorAll('.accordion__title, .accordion__button').forEach(function(el) {
    el.addEventListener('click', function (event) {
      const closest = event.target.closest('.accordion');
      if(closest.classList.contains('is-link')) {
        const url = closest.getAttribute('data-link');
        window.open(url, '_blank').focus();
      } else {
        closest.classList.toggle('open');
      }

    });
  });
